unit View.Nfe_Lote.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UUtils;

type
  TFViewNfe_LoteList = class(TForm)
    btNew: TButton;
    Nfe_LoteDataset: TXDataWebDataSet;
    Nfe_LoteDatasetid: TIntegerField;
    Nfe_LoteDatasetaliado_id: TIntegerField;
    Nfe_LoteDatasetdata_base_id: TIntegerField;
    Nfe_LoteDatasetemissao: TDateTimeField;
    Nfe_LoteDatasetcodigo: TStringField;
    Nfe_LoteDatasetquantidade_nfe: TIntegerField;
    Nfe_LoteDatasetcodigo_interno: TIntegerField;
    Nfe_LoteDatasetexcluido: TBooleanField;
    Nfe_LoteDatasetinclusao: TDateTimeField;
    Nfe_LoteDatasetalteracao: TDateTimeField;
    Nfe_LoteDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchChange(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewNfe_LoteList: TFViewNfe_LoteList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewNfe_LoteList }

procedure TFViewNfe_LoteList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewNfe_LoteList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewNfe_LoteList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewNfe_LoteList, AElementID, Result, @AfterCreate);
end;

procedure TFViewNfe_LoteList.edSearchChange(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewNfe_LoteList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewNfe_LoteList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      Nfe_LoteDataset.Connection.Model.DefaultSchema.FindEntityType(Nfe_LoteDataset.EntitySetName),
      Nfe_LoteDataset.CurrentData
    );
    Button := TButton.Create(nil);
    Button.Caption := 'Edit';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-outline btn-default btn-xs';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
  end;
end;

procedure TFViewNfe_LoteList.WebFormCreate(Sender: TObject);
begin
  TUtils.SetValorDicionarioClasses('nfe_lote', 'active');
  TUtils.SetValorDicionarioClasses('vendas_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_vendas', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    Nfe_LoteDataset,
    lcPaginator,
    lbPaginationInfo
  );
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewNfe_LoteList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.nfe_lote.list.pagination.info');
  btNew := TButton.Create('view.nfe_lote.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.nfe_lote.list.table');
  cbPageSize := TComboBox.Create('view.nfe_lote.list.cbPageSize');
  edSearch := TEdit.Create('view.nfe_lote.list.search');
  lcPaginator := TListControl.Create('view.nfe_lote.list.pagination');
  Nfe_LoteDataset := TXDataWebDataSet.Create(Self);
  Nfe_LoteDatasetid := TIntegerField.Create(Self);
  Nfe_LoteDatasetaliado_id := TIntegerField.Create(Self);
  Nfe_LoteDatasetdata_base_id := TIntegerField.Create(Self);
  Nfe_LoteDatasetemissao := TDateTimeField.Create(Self);
  Nfe_LoteDatasetcodigo := TStringField.Create(Self);
  Nfe_LoteDatasetquantidade_nfe := TIntegerField.Create(Self);
  Nfe_LoteDatasetcodigo_interno := TIntegerField.Create(Self);
  Nfe_LoteDatasetexcluido := TBooleanField.Create(Self);
  Nfe_LoteDatasetinclusao := TDateTimeField.Create(Self);
  Nfe_LoteDatasetalteracao := TDateTimeField.Create(Self);
  Nfe_LoteDatasetexclusao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  Nfe_LoteDataset.BeforeLoadDFMValues;
  Nfe_LoteDatasetid.BeforeLoadDFMValues;
  Nfe_LoteDatasetaliado_id.BeforeLoadDFMValues;
  Nfe_LoteDatasetdata_base_id.BeforeLoadDFMValues;
  Nfe_LoteDatasetemissao.BeforeLoadDFMValues;
  Nfe_LoteDatasetcodigo.BeforeLoadDFMValues;
  Nfe_LoteDatasetquantidade_nfe.BeforeLoadDFMValues;
  Nfe_LoteDatasetcodigo_interno.BeforeLoadDFMValues;
  Nfe_LoteDatasetexcluido.BeforeLoadDFMValues;
  Nfe_LoteDatasetinclusao.BeforeLoadDFMValues;
  Nfe_LoteDatasetalteracao.BeforeLoadDFMValues;
  Nfe_LoteDatasetexclusao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  try
    Name := 'FViewNfe_LoteList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliado_id';
      Title := 'aliado_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_base_id';
      Title := 'data_base_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'emissao';
      Title := 'emissao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo';
      Title := 'codigo';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'quantidade_nfe';
      Title := 'quantidade_nfe';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_interno';
      Title := 'codigo_interno';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'excluido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'inclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'alteracao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'exclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'Actions';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnChange', 'edSearchChange');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    Nfe_LoteDataset.SetParentComponent(Self);
    Nfe_LoteDataset.Name := 'Nfe_LoteDataset';
    Nfe_LoteDataset.EntitySetName := 'Nfe_Lote';
    Nfe_LoteDataset.Connection := DMConnection.ApiConnection;
    Nfe_LoteDataset.Left := 72;
    Nfe_LoteDataset.Top := 144;
    Nfe_LoteDatasetid.SetParentComponent(Nfe_LoteDataset);
    Nfe_LoteDatasetid.Name := 'Nfe_LoteDatasetid';
    Nfe_LoteDatasetid.FieldName := 'id';
    Nfe_LoteDatasetid.Required := True;
    Nfe_LoteDatasetaliado_id.SetParentComponent(Nfe_LoteDataset);
    Nfe_LoteDatasetaliado_id.Name := 'Nfe_LoteDatasetaliado_id';
    Nfe_LoteDatasetaliado_id.FieldName := 'aliado_id';
    Nfe_LoteDatasetaliado_id.Required := True;
    Nfe_LoteDatasetdata_base_id.SetParentComponent(Nfe_LoteDataset);
    Nfe_LoteDatasetdata_base_id.Name := 'Nfe_LoteDatasetdata_base_id';
    Nfe_LoteDatasetdata_base_id.FieldName := 'data_base_id';
    Nfe_LoteDatasetdata_base_id.Required := True;
    Nfe_LoteDatasetemissao.SetParentComponent(Nfe_LoteDataset);
    Nfe_LoteDatasetemissao.Name := 'Nfe_LoteDatasetemissao';
    Nfe_LoteDatasetemissao.FieldName := 'emissao';
    Nfe_LoteDatasetcodigo.SetParentComponent(Nfe_LoteDataset);
    Nfe_LoteDatasetcodigo.Name := 'Nfe_LoteDatasetcodigo';
    Nfe_LoteDatasetcodigo.FieldName := 'codigo';
    Nfe_LoteDatasetcodigo.Size := 255;
    Nfe_LoteDatasetquantidade_nfe.SetParentComponent(Nfe_LoteDataset);
    Nfe_LoteDatasetquantidade_nfe.Name := 'Nfe_LoteDatasetquantidade_nfe';
    Nfe_LoteDatasetquantidade_nfe.FieldName := 'quantidade_nfe';
    Nfe_LoteDatasetcodigo_interno.SetParentComponent(Nfe_LoteDataset);
    Nfe_LoteDatasetcodigo_interno.Name := 'Nfe_LoteDatasetcodigo_interno';
    Nfe_LoteDatasetcodigo_interno.FieldName := 'codigo_interno';
    Nfe_LoteDatasetcodigo_interno.Required := True;
    Nfe_LoteDatasetexcluido.SetParentComponent(Nfe_LoteDataset);
    Nfe_LoteDatasetexcluido.Name := 'Nfe_LoteDatasetexcluido';
    Nfe_LoteDatasetexcluido.FieldName := 'excluido';
    Nfe_LoteDatasetinclusao.SetParentComponent(Nfe_LoteDataset);
    Nfe_LoteDatasetinclusao.Name := 'Nfe_LoteDatasetinclusao';
    Nfe_LoteDatasetinclusao.FieldName := 'inclusao';
    Nfe_LoteDatasetalteracao.SetParentComponent(Nfe_LoteDataset);
    Nfe_LoteDatasetalteracao.Name := 'Nfe_LoteDatasetalteracao';
    Nfe_LoteDatasetalteracao.FieldName := 'alteracao';
    Nfe_LoteDatasetexclusao.SetParentComponent(Nfe_LoteDataset);
    Nfe_LoteDatasetexclusao.Name := 'Nfe_LoteDatasetexclusao';
    Nfe_LoteDatasetexclusao.FieldName := 'exclusao';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := Nfe_LoteDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    Nfe_LoteDataset.AfterLoadDFMValues;
    Nfe_LoteDatasetid.AfterLoadDFMValues;
    Nfe_LoteDatasetaliado_id.AfterLoadDFMValues;
    Nfe_LoteDatasetdata_base_id.AfterLoadDFMValues;
    Nfe_LoteDatasetemissao.AfterLoadDFMValues;
    Nfe_LoteDatasetcodigo.AfterLoadDFMValues;
    Nfe_LoteDatasetquantidade_nfe.AfterLoadDFMValues;
    Nfe_LoteDatasetcodigo_interno.AfterLoadDFMValues;
    Nfe_LoteDatasetexcluido.AfterLoadDFMValues;
    Nfe_LoteDatasetinclusao.AfterLoadDFMValues;
    Nfe_LoteDatasetalteracao.AfterLoadDFMValues;
    Nfe_LoteDatasetexclusao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
  end;
end;

end.
